import React from 'react';

export default () => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 14H4V0H0V14ZM8 0V14H12V0H8Z" fill="currentColor" />
  </svg>
);
